export default __webpack_public_path__ + "static/media/training-header.7cc65d49.svg";